import styled from "styled-components";

export const StyledJobPage = styled.div``;
